export default "__VITE_ASSET__d7228965__"